"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = ["id"];
const _hoisted_2 = { class: "font-bold text-[20px] mb-3 uppercase" };
const _hoisted_3 = { key: 1 };
const _hoisted_4 = { class: "text-right" };
const _hoisted_5 = ["disabled"];
const ShopInput_vue_1 = __importDefault(require("../../components/Form/ShopInput.vue"));
const vue_3 = require("vue");
const vue_router_1 = require("vue-router");
const SelectInput_vue_1 = __importDefault(require("../../components/Form/Select/SelectInput.vue"));
const CreateOrderRequest_1 = __importDefault(require("../../stores/checkout/CreateOrderRequest"));
const ShippingModeEnum_1 = require("../../stores/checkout/ShippingModeEnum");
const validators_1 = require("../../common/utils/validators");
const toastStore_1 = require("../../stores/toast/toastStore");
const checkoutStore_1 = require("../../stores/checkout/checkoutStore");
const i18n_1 = require("../../common/i18n");
const PermissionEnum_1 = require("../../models/permission/PermissionEnum");
const securityStore_1 = require("../../stores/security/securityStore");
const cartsStore_1 = require("../../stores/carts/cartsStore");
exports.default = (0, vue_1.defineComponent)({
    __name: 'ShippingMode',
    props: {
        orderRequest: {
            type: CreateOrderRequest_1.default,
        },
        id: {
            type: String,
            default: () => { var _a; return `shipping-mode-${(_a = (0, vue_3.getCurrentInstance)()) === null || _a === void 0 ? void 0 : _a.uid}`; }
        }
    },
    setup(__props) {
        const props = __props;
        const cartsStore = (0, cartsStore_1.useCartsStore)();
        const router = (0, vue_router_1.useRouter)();
        const toastStore = (0, toastStore_1.useToastStore)();
        const securityStore = (0, securityStore_1.useSecurityStore)();
        const checkoutStore = (0, checkoutStore_1.useCheckoutStore)();
        const currentUser = (0, vue_3.computed)(() => {
            return securityStore.authenticatedUser;
        });
        const activeCart = (0, vue_3.computed)(() => cartsStore.activeCart);
        const personalPickupPointAddress = (0, vue_3.computed)(() => checkoutStore.shippingAddresses.personalPickupPointAddress);
        const shippingModeOptions = (0, vue_3.computed)(() => checkoutStore.shippingModeOptions);
        const glsFormValid = (0, vue_3.computed)(() => {
            if (props.orderRequest === undefined) {
                return false;
            }
            return !(props.orderRequest.shippingGlsFlexDeliveryEmail === null ||
                props.orderRequest.shippingGlsFlexDeliveryEmail === "" ||
                props.orderRequest.shippingGlsFlexDeliveryPhone === null ||
                props.orderRequest.shippingGlsFlexDeliveryPhone === "" ||
                !(0, validators_1.isValidEmail)(props.orderRequest.shippingGlsFlexDeliveryEmail));
        });
        const submitGlsForm = () => checkoutStore.setGlsFormSubmitted(true);
        (0, vue_3.watchEffect)(() => {
            if (activeCart.value !== undefined) {
                checkoutStore
                    .getShippingModes(router, {
                    cartId: activeCart.value.id,
                })
                    .catch((error) => {
                    toastStore.addErrorToast(error.toString());
                });
            }
        });
        (0, vue_3.watch)(() => { var _a; return (_a = props.orderRequest) === null || _a === void 0 ? void 0 : _a.shippingModeId; }, () => {
            var _a;
            if (props.orderRequest === undefined) {
                return;
            }
            props.orderRequest.shippingCustomerAddressId = null;
            props.orderRequest.shippingCustomAddressName = null;
            props.orderRequest.shippingCustomAddressZipCode = null;
            props.orderRequest.shippingCustomAddressCity = null;
            props.orderRequest.shippingCustomAddressStreet = null;
            props.orderRequest.shippingCustomAddressPhone = null;
            props.orderRequest.shippingPickupPointId = null;
            props.orderRequest.shippingGlsFlexDeliveryEmail = null;
            props.orderRequest.shippingGlsFlexDeliveryPhone = null;
            props.orderRequest.paymentModeId = null;
            props.orderRequest.shippingPersonalPickupPointId = null;
            checkoutStore.resetPaymentModes();
            checkoutStore.resetExtraFees();
            checkoutStore.setGlsFormSubmitted(false);
            checkoutStore.setCustomAddressFormSubmitted(false);
            if (props.orderRequest.shippingModeId === ShippingModeEnum_1.ShippingModeEnum.PERSONAL &&
                personalPickupPointAddress.value !== null) {
                // ha nem export partner, akkor küldjük az átvételi pont ID-t is
                if (!((_a = currentUser.value) === null || _a === void 0 ? void 0 : _a.hasPermission(PermissionEnum_1.CustomerPermissionEnum.EXPORT_PARTNER))) {
                    props.orderRequest.shippingPersonalPickupPointId =
                        personalPickupPointAddress.value.id;
                }
                props.orderRequest.currentUser = currentUser.value;
                checkoutStore
                    .getPaymentModes(router, {
                    cartId: activeCart.value.id,
                    shippingId: props.orderRequest.shippingModeId,
                    cartCurrency: activeCart.value.getCurrencyCode() || '',
                })
                    .catch((error) => {
                    toastStore.addErrorToast(error.toString());
                });
                return;
            }
        });
        // Ha csak egy szállítási mód elérhető, automatikusan kiválasztjuk azt.
        (0, vue_3.watch)(shippingModeOptions, (options) => {
            if (props.orderRequest &&
                options.length === 1 &&
                !props.orderRequest.shippingModeId) {
                // eslint-disable-next-line vue/no-mutating-props
                props.orderRequest.shippingModeId = options[0].value;
            }
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                id: __props.id,
                class: "mb-3 border-b-2 border-[#929292]"
            }, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("first_step_shipping_mode", "1. step - Shipping mode", "checkout")), 1),
                (__props.orderRequest !== undefined)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(SelectInput_vue_1.default, {
                        key: 0,
                        id: "shipping-mode-select-input",
                        classes: "border-0",
                        class: "mb-5",
                        "placeholder-enable": true,
                        placeholder: (0, vue_2.unref)(i18n_1.trans)('shipping_modes_placeholder', 'Please select', 'checkout'),
                        modelValue: __props.orderRequest.shippingModeId,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((__props.orderRequest.shippingModeId) = $event)),
                        options: (0, vue_2.unref)(shippingModeOptions)
                    }, null, 8, ["placeholder", "modelValue", "options"]))
                    : (0, vue_2.createCommentVNode)("", true),
                (__props.orderRequest !== undefined &&
                    __props.orderRequest.shippingModeId ===
                        (0, vue_2.unref)(ShippingModeEnum_1.ShippingModeEnum).GLS_FLEX_DELIVERY)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_3, [
                        (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                            id: "shipping-mode-gls-email-input",
                            placeholder: (0, vue_2.unref)(i18n_1.trans)('gls_shipping_mode_email_placeholder', 'Email', 'checkout'),
                            modelValue: __props.orderRequest.shippingGlsFlexDeliveryEmail,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((__props.orderRequest.shippingGlsFlexDeliveryEmail) = $event)),
                            class: "mb-3",
                            "show-validity": true,
                            valid: !(0, vue_2.unref)(validators_1.isBlank)(__props.orderRequest.shippingGlsFlexDeliveryEmail) &&
                                (0, vue_2.unref)(validators_1.isValidEmail)(__props.orderRequest.shippingGlsFlexDeliveryEmail),
                            type: "email",
                            required: "",
                            border: ""
                        }, null, 8, ["placeholder", "modelValue", "valid"]),
                        (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                            id: "shipping-mode-gls-phone-input",
                            placeholder: (0, vue_2.unref)(i18n_1.trans)('gls_shipping_mode_phone_placeholder', 'Phone', 'checkout'),
                            modelValue: __props.orderRequest.shippingGlsFlexDeliveryPhone,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((__props.orderRequest.shippingGlsFlexDeliveryPhone) = $event)),
                            class: "mb-3",
                            "show-validity": true,
                            valid: !(0, vue_2.unref)(validators_1.isBlank)(__props.orderRequest.shippingGlsFlexDeliveryPhone),
                            type: "tel",
                            required: "",
                            border: ""
                        }, null, 8, ["placeholder", "modelValue", "valid"]),
                        (0, vue_2.createElementVNode)("div", _hoisted_4, [
                            (0, vue_2.createElementVNode)("button", {
                                id: "shipping-mode-gls-submit-form-button",
                                disabled: !(0, vue_2.unref)(glsFormValid),
                                class: "btn btn-rounded btn-primary !inline-flex text-sm sm:text-base h-[63px] font-bold text-[20px] my-3",
                                onClick: _cache[3] || (_cache[3] = ($event) => (submitGlsForm()))
                            }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("shipping_mode_gls_submit", "Next", "checkout")), 9, _hoisted_5)
                        ])
                    ]))
                    : (0, vue_2.createCommentVNode)("", true)
            ], 8, _hoisted_1));
        };
    }
});
